import { useState, useEffect } from 'react';
import { db } from '../../../firebase/config';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';

export function useAppFiles(appId) {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!appId) { setLoading(false); return; }
    const q = query(
      collection(db, 'applab_apps', appId, 'files'),
      orderBy('uploadedAt', 'desc')
    );
    const unsub = onSnapshot(q, snap => {
      setFiles(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    }, () => setLoading(false));
    return unsub;
  }, [appId]);

  return { files, loading };
}
